import React, {Component} from 'react';
import { Checkbox, FormControlLabel } from '@material-ui/core';

class FeedbackOption extends Component{

    render() {
        let classLabel = '';
        if(this.props.handleCheck){
            classLabel="feedback-checkboxSelected";
        }
        return (
            <div className="feedback-option">
                <div className={classLabel}>
                    <FormControlLabel
                        control={
                        <Checkbox
                            checked={this.props.handleCheck}
                            onChange={this.props.onClick}
                            color="primary"
                            id={this.props.id}
                        />
                        }
                        label={this.props.option} 
      />
                </div>
         </div>
        )
    }
} 
export default FeedbackOption;